import "./NursingCaregiverHodHasharonWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import TuSocioEstrategicoParaGrandesDesafios from "./sections/TuSocioEstrategicoParaGrandesDesafios";
import NeighborhoodServiceAreas from "./sections/NeighborhoodServiceAreas";
import RelatedServices from "./sections/RelatedServices";
import FaqAccordion from "./sections/FaqAccordion";
import BookYourChateauguayService from "./sections/BookYourChateauguayService";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverHodHasharonWithinHoursPage() {
  return <div>
      <Header />
      <TuSocioEstrategicoParaGrandesDesafios />
      <NeighborhoodServiceAreas />
      <RelatedServices />
      <FaqAccordion />
      <BookYourChateauguayService />
      <Footer />
    </div>;
}